/**
 * Audio Configuration for Tonal Influence Audiobook Integration
 * Maps LLM.pdf chapters to modules with Fast Focus points
 * 
 * Google Drive folder: https://drive.google.com/drive/folders/1AtJtwbKksw64SvLTwHvcO_9EcvcUAQZ-
 * Total: 65 audio files
 */

// Google Drive file IDs - ALL 65 FILES VERIFIED
const DRIVE_FILE_IDS = {
  "600 Pounds": "1XGYEuxruxsgHElsv4-9lxy7dfIiGDxUs",
  "A Mutant, A Wizard and A Maestro": "1tPYy7UamenGNDaDWHNEMJjJT3VqonePZ",
  "Alotta Real Estate": "1ZaCRUDzw62yWXmCNv7K8Y8mqeTawMLBq",
  "Animated Discussion": "1EbEyko3I76MDqHZ7SZtavCbqvTZtBvoT",
  "Assume No Harm": "1uGfM7wjoSn4webJ4-aFm6uaw5xfr9P96",
  "Audition": "1qdASzfMe4QJNLoSP34EGql65g-g_d-KY",
  "Bob Ross": "1gfDTU50jM6kXgHmK_IYwapako7O1xLhP",
  "Bosu Imbalance": "1uyKq_NCZOqxirnqAHv0algOO9z1HRO_2",
  "Call It Out, Bring It On, Bring It In": "1N01zYp3-XpwpIz-KRxxXMOHxpsO_CXG3",
  "Catch More Bees": "1FeMNzH-pCIKvzaSacKyJ0vlpCTdGkOCB",
  "Cheap Filler": "12xrZDRD1QcdMTbdB_f5kXXa5JiC8OAVg",
  "Conga Lines, Conductors and Concerts": "1nqCXbIiHXOogWLz6MJhqIFF4jIubhOVY",
  "For Your Own Good": "10USzXE9QGYsP8ttrug3t_UwpVqObopfq",
  "Foreword": "1L3AQrmBh2AsC0im5rqOuWcfcwHNufH2n",
  "Fortnite and Fortresses": "1GcYhB4P09RRc_IEt9ByqU4Z-eHDe6fJY",
  "Head And Shoulders": "1xD9nuS0nRKsBDqY3hsplKOHgLw9XDsVJ",
  "Hello, Where Are You Going": "1utvlwceY6PhJwUfXxGDVFaeZRccbDgtO",
  "How Do You Look": "1K-rGXnzdKLsfsmfHlVvjMR7C1gUus4qV",
  "How To Be A Model": "1DtURNJhR_YbgoBG5KEmLJEU5lUp5Vl0S",
  "How To Wait": "1bqFYV37qpDvZUr-nS3r71tT56VgX35RE",
  "Huddles, Helmets and Going Head To Head": "1dvTkHz20Z1SE_Rdr0Zbfmu9ba4ynl33w",
  "If, And, Or, But": "1T5QIWnRCYhOch3dE5DfGWF49Q6HmYD2J",
  "Imaginary Lines": "1aYkt14dJ1y-HMBg96_xrVJhusnpvRT7B",
  "Isn't That Something": "1IKQ_Pevm-EMsFd4sidi7Lf67P7-nsMoh",
  "It's All In Your Head": "194gM2ICiuSp7wbzUD7GPfGHfgxx7ZTe-",
  "Keep In Touch": "1zmfTBQTOnyNW_ms8l_Z364Y90EIHi2YJ",
  "Lip Every Voice": "19bOefZLFmhW80hzvMt_6bQJ16vjTuWGX",
  "Mayweather": "1Z0TeOFfpPxPozzJfG_mQzt25CqPZwFtT",
  "Mr. Sniffles": "1obA0URaKpXkNFOakRO6S3KsnJzNazrY-",
  "Nature": "1YdJJbuPYTsIo02y_CxOFPbpYxUproj6z",
  "One More Thing": "1XrAifOeTHV_vjJ0oSIHvkH3yudZXRgSu",
  "Onward": "1A37WseX4rdmnLwuoP98gKSIjDFzjWVcq",
  "Open Arms": "1NrOcvV1B4LnKrdO1XEiZILO7ZtcujCM1",
  "Our First Inheritance": "1oaBcN0z5GVXSaGcTVqRermrkrH78pquF",
  "Personare": "1DtLIYOqvz1rfFveQCbl9_kG7oTa8Xg6s",
  "Posture Is A Verb": "1s1JPzudGdsB9coYHPI0U4yWD4MzkKTj2",
  "Preface": "1XqbhmTYGl0617ifoRErfysy0JoX7wPKr",
  "Q&A": "1LWZY5LpS4Wpi-MSvysVKOsTPAgrfIe-U",
  "Quiet Confidence": "1iQNqr4jjZqwsQHEwrjmXbk99mUnjuBFb",
  "Read The Room And Insult Everyone": "1BQh411PACVEOqbEjJdGRDn6bBHhe0e2m",
  "Ring The Alarm, Please Don't Call 911": "1z6BanJRkfHczMpile6VFR5i9J80iuUM0",
  "Run And Hide": "1WQ0DGPxAObWOiFeec-wTJ2HLzqaNj1Gs",
  "Singers, Salt Bae And Precision": "1ArJtQijnc9IPUxDtcSCTKkbABOThBLgf",
  "Somebody's Son": "1C2ONU5_kiftEv7xNMDaH6igAZorIHE1i",
  "Squinch Your Little Heart": "10QozJffRbIkElhAf5T0pq6-ckeZvx6W3",
  "Sticks, Stones and Needles": "1k2i43VRcWnGMqBLxAkwY1z4zgtAql7XB",
  "Stomping Grounds": "1xtRHYBSTtKvlE7C4HFBqyC143_5RCQG5",
  "Straight Away, Roundabout": "1hm1Z0IHtrHP56qFb-3WOr9caMxQIYnOI",
  "Strike One": "16fTRgBpQQ-Oedv6tBeoecWO_wFpfIXne",
  "Taking Turns": "1SWCDB5yIXgqnbHxnpRVMe8LtSt_NNx9o",
  "Talking Is Dangerous": "1el9tRue6HMiX1oaEIdCm_7wFAS09tITg",
  "Telephone": "1C892Ek-k8TqSe6c-tsGqMm81R9p798Jb",
  "Text N Necks": "1xLi6FlRHD8v8A5g3j_S4FVBqVE_8APVy",
  "The Pinky And The Brain": "1vj9Na7hK3AH2RTGDQ30g6ZM96o45UXPX",
  "The Threat": "1Z-9X1mdiC7U718KbHxJaWBf40jQ1TTjL",
  "The Wind": "1f-PF2OVPRRju9CzVCseBTsiu15Nb-GaR",
  "Through Thick And Thin": "1pEV1jcPND1DgPykiFZBK-PDMVlyeMnNP",
  "Title": "1PpyoYd5yvH-KFWuas7R3Quwdda_ctdzU",
  "Tune To The Road": "1J2pAbHFD9Hq5gujPdSJJPYzfTPVhp7q3",
  "Walkie Talkie": "1AOpBorA_PNh0ztldRx-gXkj7t8bl0fqI",
  "What's Going On": "13ukNUO2Ce92eNJfXnMYM0hluPehWLwq4",
  "Whitney": "15SExvSpvbpdQrWwLir4BStONUU0-8wMg",
  "Yes And No...Maybe": "1hagiCoavTdI7Y2n5_f3Ax_CRhAOq82yw",
  "You Gross": "1ZRQQl59GD9gnYadi6nfhO5qmVBnCZ9Yo",
  "You Sound Like Me": "1O85a4rzQpy4ClPFi--RPQTQAbRphArSb"
};

/**
 * Get audio URL using our backend proxy
 */
export const getAudioUrl = (fileId) => {
  if (!fileId) return null;
  const API_URL = process.env.REACT_APP_BACKEND_URL || '';
  return `${API_URL}/api/audio/gdrive/${fileId}`;
};

// =============================================================================
// DAILY SPEAKING AUDIO - Matches VoicePractice DAILY_READINGS by day number
// Each day has ONE specific audio that matches the session title
// =============================================================================
export const DAILY_SPEAKING_AUDIO = [
  {
    day: 1,
    title: "How To Wait",
    name: "How To Wait",
    fileId: DRIVE_FILE_IDS["How To Wait"],
    fastFocus: "Relax your hands. Keep them still and calm while you speak. The root of 'wait' is 'watch'—examine before you respond.",
    voiceAnalysisFocus: "Controlled pauses between sentences",
    duration: "~4 min"
  },
  {
    day: 2,
    title: "Tune to the Road",
    name: "Tune To The Road",
    fileId: DRIVE_FILE_IDS["Tune To The Road"],
    fastFocus: "Make small adjustments without changing who you are. Treat this as new terrain—tune yourself to it while staying grounded.",
    voiceAnalysisFocus: "Grounded stability in conversation",
    duration: "~4 min"
  },
  {
    day: 3,
    title: "Quiet Confidence",
    name: "Quiet Confidence",
    fileId: DRIVE_FILE_IDS["Quiet Confidence"],
    fastFocus: "Speak with inner trust, not outward display. Confidence is a quietude—a secret knowing. Let your voice carry that quiet power.",
    voiceAnalysisFocus: "Drawing people in with quiet authority",
    duration: "~4 min"
  },
  {
    day: 4,
    title: "Nature's Reset",
    name: "Nature",
    fileId: DRIVE_FILE_IDS["Nature"],
    fastFocus: "Yawn before you begin. Let it loosen your throat muscles. Take a deep breath and let your body reset before speaking.",
    voiceAnalysisFocus: "Grounding breaths to reduce vocal tension",
    duration: "~5 min"
  },
  {
    day: 5,
    title: "Straight Away - Round About",
    name: "Straight Away, Roundabout",
    fileId: DRIVE_FILE_IDS["Straight Away, Roundabout"],
    fastFocus: "Move your arms as you speak. Straight lines for direct words, sweeping motions for flow. You are the conductor of your voice.",
    voiceAnalysisFocus: "Increase vocal variety to engage listeners",
    duration: "~5 min"
  }
];

/**
 * Get speaking audio for a specific day - matches DAILY_READINGS in VoicePractice
 * @param {number} day - Day number (1-5)
 * @returns {Object} Audio data with title, fileId, fastFocus, voiceAnalysisFocus
 */
export const getDailySpeakingAudio = (day) => {
  const dayIndex = ((day - 1) % 5);  // Cycle through 5 days
  const audioData = DAILY_SPEAKING_AUDIO[dayIndex];
  
  return {
    audio: {
      name: audioData.name,
      fileId: audioData.fileId,
      duration: audioData.duration
    },
    title: audioData.title,
    fastFocus: audioData.fastFocus,
    voiceAnalysisFocus: audioData.voiceAnalysisFocus,
    day: day,
    cycleDay: dayIndex + 1
  };
};

// =============================================================================
// LISTENING AUDIO - For Field Practice module
// Organized by listening criteria from the assessment
// =============================================================================
export const LISTENING_AUDIO = {
  say: {
    name: "SAY - What They Said",
    description: "Focus on the actual words being spoken",
    audios: [
      { name: "Talking Is Dangerous", fileId: DRIVE_FILE_IDS["Talking Is Dangerous"], duration: "~5 min", fastFocus: "Listen for the exact words. What did they actually say vs what you assumed?" },
      { name: "If, And, Or, But", fileId: DRIVE_FILE_IDS["If, And, Or, But"], duration: "~4 min", fastFocus: "Notice connecting words. They reveal how ideas link together." },
      { name: "Cheap Filler", fileId: DRIVE_FILE_IDS["Cheap Filler"], duration: "~4 min", fastFocus: "Filter out filler words. Find the core message underneath." }
    ]
  },
  time: {
    name: "TIME - When They Said It",
    description: "Understanding timing and context",
    audios: [
      { name: "How To Wait", fileId: DRIVE_FILE_IDS["How To Wait"], duration: "~4 min", fastFocus: "Timing matters. Notice when something is said, not just what." },
      { name: "Taking Turns", fileId: DRIVE_FILE_IDS["Taking Turns"], duration: "~5 min", fastFocus: "Conversations have rhythm. Notice the natural pauses." },
      { name: "Strike One", fileId: DRIVE_FILE_IDS["Strike One"], duration: "~4 min", fastFocus: "First impressions in timing. What gets said first matters." }
    ]
  },
  attention: {
    name: "ATTENTION - Focus Patterns",
    description: "Where attention is directed",
    audios: [
      { name: "The Pinky And The Brain", fileId: DRIVE_FILE_IDS["The Pinky And The Brain"], duration: "~5 min", fastFocus: "Notice what captures attention. What are they focused on?" },
      { name: "Squinch Your Little Heart", fileId: DRIVE_FILE_IDS["Squinch Your Little Heart"], duration: "~4 min", fastFocus: "Eye contact and attention. Where are they really looking?" },
      { name: "Text N Necks", fileId: DRIVE_FILE_IDS["Text N Necks"], duration: "~4 min", fastFocus: "Modern attention challenges. Presence vs distraction." }
    ]
  },
  respect: {
    name: "RESPECT - Reading Status",
    description: "Understanding social dynamics",
    audios: [
      { name: "600 Pounds", fileId: DRIVE_FILE_IDS["600 Pounds"], duration: "~5 min", fastFocus: "Weight of words. Some words carry more authority than others." },
      { name: "Catch More Bees", fileId: DRIVE_FILE_IDS["Catch More Bees"], duration: "~4 min", fastFocus: "Honey vs vinegar. Tone shapes how messages are received." },
      { name: "How Do You Look", fileId: DRIVE_FILE_IDS["How Do You Look"], duration: "~4 min", fastFocus: "Visual cues of respect. What does their body language say?" }
    ]
  },
  level_path: {
    name: "LEVEL PATH - Journey Direction",
    description: "Understanding where the conversation is going",
    audios: [
      { name: "Straight Away, Roundabout", fileId: DRIVE_FILE_IDS["Straight Away, Roundabout"], duration: "~5 min", fastFocus: "Direct vs indirect communication. Both have their place." },
      { name: "Stomping Grounds", fileId: DRIVE_FILE_IDS["Stomping Grounds"], duration: "~5 min", fastFocus: "Territory and comfort zones. Where do they feel safe?" },
      { name: "Hello, Where Are You Going", fileId: DRIVE_FILE_IDS["Hello, Where Are You Going"], duration: "~4 min", fastFocus: "Destination clarity. Where is this conversation headed?" }
    ]
  },
  emotion: {
    name: "EMOTION - Feeling Tones",
    description: "Reading emotional undercurrents",
    audios: [
      { name: "Whitney", fileId: DRIVE_FILE_IDS["Whitney"], duration: "~5 min", fastFocus: "Emotional range. Listen for the feelings behind the words." },
      { name: "Bob Ross", fileId: DRIVE_FILE_IDS["Bob Ross"], duration: "~5 min", fastFocus: "Calm in expression. How do they manage their emotional tone?" },
      { name: "Nature", fileId: DRIVE_FILE_IDS["Nature"], duration: "~4 min", fastFocus: "Natural emotional rhythms. Let feelings breathe." }
    ]
  },
  meaning: {
    name: "MEANING - Deeper Intent",
    description: "Finding the message beneath the message",
    audios: [
      { name: "Isn't That Something", fileId: DRIVE_FILE_IDS["Isn't That Something"], duration: "~4 min", fastFocus: "Subtext awareness. What are they really trying to say?" },
      { name: "It's All In Your Head", fileId: DRIVE_FILE_IDS["It's All In Your Head"], duration: "~5 min", fastFocus: "Perception shapes meaning. Your interpretation matters." },
      { name: "Quiet Confidence", fileId: DRIVE_FILE_IDS["Quiet Confidence"], duration: "~4 min", fastFocus: "Unspoken confidence. Some things don't need to be said." }
    ]
  },
  connection: {
    name: "CONNECTION - Building Rapport",
    description: "Creating and maintaining connection",
    audios: [
      { name: "Keep In Touch", fileId: DRIVE_FILE_IDS["Keep In Touch"], duration: "~4 min", fastFocus: "Maintaining connection. Small touchpoints matter." },
      { name: "Open Arms", fileId: DRIVE_FILE_IDS["Open Arms"], duration: "~4 min", fastFocus: "Physical openness signals. Body language of connection." },
      { name: "You Sound Like Me", fileId: DRIVE_FILE_IDS["You Sound Like Me"], duration: "~4 min", fastFocus: "Mirroring in communication. Similarity builds rapport." }
    ]
  },
  response: {
    name: "RESPONSE - Reaction Patterns",
    description: "How to respond effectively",
    audios: [
      { name: "Call It Out, Bring It On, Bring It In", fileId: DRIVE_FILE_IDS["Call It Out, Bring It On, Bring It In"], duration: "~5 min", fastFocus: "Three response modes. Name it, engage it, or embrace it." },
      { name: "Read The Room And Insult Everyone", fileId: DRIVE_FILE_IDS["Read The Room And Insult Everyone"], duration: "~5 min", fastFocus: "Situational awareness. Adapt your response to the context." },
      { name: "Yes And No...Maybe", fileId: DRIVE_FILE_IDS["Yes And No...Maybe"], duration: "~4 min", fastFocus: "Flexible responses. Not everything needs a firm answer." }
    ]
  }
};

/**
 * Get listening audio for a specific criterion and cycle
 * @param {string} criterion - Listening criterion (say, time, attention, etc.)
 * @param {number} cycle - Which audio in the cycle (1-3)
 * @returns {Object} Audio data
 */
export const getListeningAudioForCycle = (criterion, cycle) => {
  const criterionData = LISTENING_AUDIO[criterion];
  if (!criterionData) return null;
  
  const audioIndex = (cycle - 1) % criterionData.audios.length;
  const audio = criterionData.audios[audioIndex];
  
  return {
    audio: {
      name: audio.name,
      fileId: audio.fileId,
      duration: audio.duration
    },
    fastFocus: audio.fastFocus,
    criterionName: criterionData.name,
    description: criterionData.description,
    cycle: cycle,
    audioNumber: audioIndex + 1,
    totalAudios: criterionData.audios.length
  };
};

// =============================================================================
// FOUNDATION AUDIO - For core learning concepts
// =============================================================================
export const FOUNDATION_AUDIO = {
  introduction: [
    { name: "Foreword", fileId: DRIVE_FILE_IDS["Foreword"], duration: "~3 min", topic: "Welcome and overview" },
    { name: "Preface", fileId: DRIVE_FILE_IDS["Preface"], duration: "~4 min", topic: "Setting the foundation" },
    { name: "Title", fileId: DRIVE_FILE_IDS["Title"], duration: "~2 min", topic: "What this is all about" }
  ],
  bodyLanguage: [
    { name: "Posture Is A Verb", fileId: DRIVE_FILE_IDS["Posture Is A Verb"], duration: "~5 min", topic: "Active positioning" },
    { name: "Head And Shoulders", fileId: DRIVE_FILE_IDS["Head And Shoulders"], duration: "~4 min", topic: "Upper body presence" },
    { name: "Bosu Imbalance", fileId: DRIVE_FILE_IDS["Bosu Imbalance"], duration: "~4 min", topic: "Finding your center" },
    { name: "Alotta Real Estate", fileId: DRIVE_FILE_IDS["Alotta Real Estate"], duration: "~5 min", topic: "Taking up space" }
  ],
  voiceWork: [
    { name: "A Mutant, A Wizard and A Maestro", fileId: DRIVE_FILE_IDS["A Mutant, A Wizard and A Maestro"], duration: "~5 min", topic: "Voice archetypes" },
    { name: "Personare", fileId: DRIVE_FILE_IDS["Personare"], duration: "~4 min", topic: "Voice as persona" },
    { name: "Animated Discussion", fileId: DRIVE_FILE_IDS["Animated Discussion"], duration: "~5 min", topic: "Bringing energy" },
    { name: "Singers, Salt Bae And Precision", fileId: DRIVE_FILE_IDS["Singers, Salt Bae And Precision"], duration: "~4 min", topic: "Precision in delivery" }
  ],
  presence: [
    { name: "Audition", fileId: DRIVE_FILE_IDS["Audition"], duration: "~4 min", topic: "Being present under pressure" },
    { name: "How To Be A Model", fileId: DRIVE_FILE_IDS["How To Be A Model"], duration: "~4 min", topic: "Modeling presence" },
    { name: "Telephone", fileId: DRIVE_FILE_IDS["Telephone"], duration: "~4 min", topic: "Presence without visuals" },
    { name: "Walkie Talkie", fileId: DRIVE_FILE_IDS["Walkie Talkie"], duration: "~4 min", topic: "Back and forth presence" }
  ],
  advanced: [
    { name: "Mayweather", fileId: DRIVE_FILE_IDS["Mayweather"], duration: "~5 min", topic: "Defensive communication" },
    { name: "Fortnite and Fortresses", fileId: DRIVE_FILE_IDS["Fortnite and Fortresses"], duration: "~5 min", topic: "Building verbal structures" },
    { name: "Huddles, Helmets and Going Head To Head", fileId: DRIVE_FILE_IDS["Huddles, Helmets and Going Head To Head"], duration: "~5 min", topic: "Team dynamics" },
    { name: "The Threat", fileId: DRIVE_FILE_IDS["The Threat"], duration: "~4 min", topic: "Managing confrontation" },
    { name: "Run And Hide", fileId: DRIVE_FILE_IDS["Run And Hide"], duration: "~4 min", topic: "Strategic retreat" }
  ],
  mindset: [
    { name: "Assume No Harm", fileId: DRIVE_FILE_IDS["Assume No Harm"], duration: "~4 min", topic: "Positive assumptions" },
    { name: "For Your Own Good", fileId: DRIVE_FILE_IDS["For Your Own Good"], duration: "~4 min", topic: "Self-care in communication" },
    { name: "One More Thing", fileId: DRIVE_FILE_IDS["One More Thing"], duration: "~3 min", topic: "Final thoughts" },
    { name: "Onward", fileId: DRIVE_FILE_IDS["Onward"], duration: "~3 min", topic: "Moving forward" }
  ]
};

/**
 * Get audio by chapter name (for personalized recommendations)
 * This allows looking up audio by the chapter title from recommendations
 * @param {string} chapterName - The chapter/lesson name from the recommendation
 * @returns {Object|null} Audio data with fileId, name, and fastFocus
 */
export const getAudioByChapterName = (chapterName) => {
  if (!chapterName) return null;
  
  // Normalize the name for comparison (handle slight variations)
  const normalizedInput = chapterName.toLowerCase().trim();
  
  // First, check DRIVE_FILE_IDS directly
  for (const [name, fileId] of Object.entries(DRIVE_FILE_IDS)) {
    if (name.toLowerCase() === normalizedInput || 
        name.toLowerCase().includes(normalizedInput) ||
        normalizedInput.includes(name.toLowerCase())) {
      return {
        name: name,
        fileId: fileId,
        fastFocus: getChapterFastFocus(name)
      };
    }
  }
  
  // Also check DAILY_SPEAKING_AUDIO for fastFocus content
  const dailyMatch = DAILY_SPEAKING_AUDIO.find(d => 
    d.name.toLowerCase() === normalizedInput ||
    d.title?.toLowerCase() === normalizedInput
  );
  if (dailyMatch) {
    return {
      name: dailyMatch.name,
      fileId: dailyMatch.fileId,
      fastFocus: dailyMatch.fastFocus
    };
  }
  
  return null;
};

/**
 * Get Fast Focus content for a chapter
 */
const getChapterFastFocus = (chapterName) => {
  // Check DAILY_SPEAKING_AUDIO
  const dailyMatch = DAILY_SPEAKING_AUDIO.find(d => d.name === chapterName || d.title === chapterName);
  if (dailyMatch?.fastFocus) return dailyMatch.fastFocus;
  
  // Check LISTENING_AUDIO
  for (const criterion of Object.values(LISTENING_AUDIO)) {
    const audioMatch = criterion.audios?.find(a => a.name === chapterName);
    if (audioMatch?.fastFocus) return audioMatch.fastFocus;
  }
  
  // Check FOUNDATION_AUDIO
  for (const category of Object.values(FOUNDATION_AUDIO)) {
    const foundMatch = category.find(a => a.name === chapterName);
    if (foundMatch?.topic) return foundMatch.topic;
  }
  
  return `Focus on the principles of "${chapterName}" and how they apply to your communication style.`;
};

// Export all audio configurations
export default { 
  DRIVE_FILE_IDS,
  DAILY_SPEAKING_AUDIO,
  LISTENING_AUDIO, 
  FOUNDATION_AUDIO,
  getAudioUrl,
  getDailySpeakingAudio,
  getListeningAudioForCycle,
  getAudioByChapterName
};
